/**
 * Returns a correctly pluralized Ukrainian phrase for contract expirations.
 * @param {number} count - The number of expiring contracts.
 * @returns {string} A string like "Закінчується 1 договір" or "Закінчуються 3 договори"
 */
function getContractExpirationText(count) {
  const forms = ['договір', 'договори', 'договорів'];

  const getPluralForm = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return forms[0];
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return forms[1];
    return forms[2]; // 5+
  };

  const verb = count === 1 ? 'Закінчується' : 'Закінчуються';

  return `${verb} ${count} ${getPluralForm(count)}`;
}

/**
 * Groups order prolongation items by contract finish date.
 *
 * This function processes raw backend data to count how many orders
 * are associated with each `contract.finishedAt` date.
 * @param {object | null | undefined} backendData - Raw backend data expected to contain an `items` array.
 * @param {Array<object>} backendData.items - An array of order items, each possibly containing a `contract.finishedAt` field.
 * @returns {Array<{ title: string, date: string }>} An array of objects
 * Returns an empty array if input is invalid or `items` is not an array.
 */
export function prepareOrdersProlongationList(backendData) {
  if (!backendData || !Array.isArray(backendData?.items)) {
    return [];
  }

  const grouped = backendData.items.reduce((acc, item) => {
    const date = item?.contract?.finishedAt;
    if (!date) return acc;

    acc[date] = (acc[date] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(grouped).map(([date, count]) => ({
    title: getContractExpirationText(count),
    date: date,
    route: { name: 'prolongation', query: { finishedFrom: date } },
  }));
}
